import React from "react";
import { Route, Routes } from "react-router-dom";
import CandidatureDetailsPage from "../../pages/module-pages/candidatures/CandidatureDetailsPage";
import CandidaturesPage from "../../pages/module-pages/candidatures/CandidaturesPage";

export default function CandidatureNav() {
  return (
    <Routes>
      <Route path="/" element={<CandidaturesPage />} />
      <Route path="/:id" element={<CandidatureDetailsPage />} />
    </Routes>
  );
}
